﻿import { convertToDateExtractor } from './date.extract';
import { convertToDateFormatter } from './date.format';

/**
 * Convert any value to a native date
 * @param value 
 * @returns a native date or null if parsed failed
 */
export function convertToDate(value: string | number | Date): Date | null {
    if (value === undefined || value === null) {
        return null;
    }
    if (value instanceof Date && isNaN(value.getTime()) === false) {
        return value;
    }
    let parsedDate;
    if (typeof value === 'string') {
        if (value.indexOf('"') === 0) {
            // maybe a json date
            try {
                parsedDate = new Date(JSON.parse(String(value)));
                parsedDate = new Date(parsedDate.getUTCFullYear(),
                    parsedDate.getUTCMonth(),
                    parsedDate.getUTCDate(),
                    parsedDate.getUTCHours(),
                    parsedDate.getUTCMinutes(),
                    parsedDate.getUTCSeconds());
            } catch {
                // do nothing
            }
        } else {
            try {
                parsedDate = new Date(String(value));
                parsedDate = new Date(parsedDate.getUTCFullYear(),
                    parsedDate.getUTCMonth(),
                    parsedDate.getUTCDate(),
                    parsedDate.getUTCHours(),
                    parsedDate.getUTCMinutes(),
                    parsedDate.getUTCSeconds());
            } catch {
                // do nothing
            }
        }
    } else {
        try {
            parsedDate = new Date(value);
        } catch {
            // do nothing
        }
    }
    if (parsedDate && parsedDate instanceof Date && isNaN(parsedDate.getTime()) === false) {
        return parsedDate;
    } else {
        return null;
    }
}

/**
 * Convert a native date to JSON string (Date only)
 * @param value 
 * @returns a JSON string or null if parsed failed
 */
export function convertToJsonDate(value: Date | null | undefined): string | null {
    if (value && value instanceof Date && isNaN(value.getTime()) === false) {
        const jsonDate = `${value.getFullYear()}-${fixZero(value.getMonth() + 1)}-${fixZero(value.getDate())}`;
        return jsonDate;
    } else {
        return null;
    }
}

/**
 * onvert a native date to JSON string (Date and Time)
 * @param value 
 * @returns a JSON string or null if parsed failed
 */
export function convertToJsonDateTime(value: Date | null | undefined): string | null {
    if (value && value instanceof Date && isNaN(value.getTime()) === false) {
        const jsonDate = `${value.getFullYear()}-${fixZero(value.getMonth() + 1)}-${fixZero(value.getDate())}T${fixZero(value.getHours())}:${fixZero(value.getMinutes())}:${fixZero(value.getSeconds())}`;
        return jsonDate;
    } else {
        return null;
    }
}

function fixZero(value: number): string {
    if (value < 10) {
        return '0' + value;
    } else {
        return value.toString();
    }
}

/**
 * Check if a date (Date only, without time part) is in array
 * @param array 
 * @param date 
 * @returns Return the founded index, and -1 if not found
 */
export function isDateInArray(array: Date[] | null | undefined, date: Date): number {
    if (array && array.length > 0) {
        for (let i = 0; i < array.length; i++) {
            const currentDate = array[i];
            if (currentDate.getFullYear() === date.getFullYear()
                && currentDate.getMonth() === date.getMonth()
                && currentDate.getDate() === date.getDate()) {
                return i;
            }
        }
    }
    return -1;
}

export function convertToDateByFormat(value: string, format: string): Date | null {
    if (value && format) {
        const ext = convertToDateExtractor(format);
        if (ext != null) {
            return ext.convertToDate(value, true);
        }
    }
    return null;
}

export function tryConvertToDateByFormat(value: string, format: string): Date | null {
    if (value && format) {
        const ext = convertToDateExtractor(format);
        if (ext != null) {
            return ext.convertToDate(value, false);
        }
    }
    return null;
}

export function formatDate(date: Date, format: string): string {
    if (date && format) {
        const formatter = convertToDateFormatter(format);
        if (formatter != null) {
            return formatter.format(date);
        }
    }
    return '';
}